import React, { useState } from "react";
import { MdPerson, MdEmail, MdMessage, MdSend } from "react-icons/md";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div 
      name="contact"
      className="relative w-full bg-[#080d14] pt-6 sm:pt-8 md:pt-10 pb-4 sm:pb-6 md:pb-8 text-white overflow-hidden"
    >

      <div className="relative flex flex-col justify-center max-w-screen-lg mx-auto px-6 md:px-8">
        {/* Header */}
        <div className="mb-4 sm:mb-6 md:mb-8 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="h-1 w-8 sm:w-12 bg-blue-500"></div>
            <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight">
              Contact
            </h3>
            <div className="h-1 w-8 sm:w-12 bg-blue-500"></div>
          </div>
          <p className="text-gray-300 text-xs sm:text-sm md:text-base lg:text-lg font-normal px-2">
            Let's connect and discuss how we can work together
          </p>
        </div>

        {/* Form Container */}
        <div className="flex justify-center items-center w-full">
          <form 
            action="https://getform.io/f/a73067e1-429b-4a45-a9a8-613691e3cc0a" 
            method="POST" 
            className="w-full sm:w-full md:w-2/3 lg:w-1/2 xl:w-2/5 space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6"
          >
            {/* Name Input */}
            <div className="relative group">
              <div className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 z-10">
                <div className="relative">
                  {/* Glow effect */}
                  <div className="absolute inset-0 bg-blue-500/30 rounded-lg blur-md opacity-0 group-focus-within:opacity-100 transition-opacity duration-300"></div>
                  {/* Icon container */}
                  <div className="relative bg-gradient-to-br from-blue-600/20 to-cyan-600/20 backdrop-blur-sm border border-blue-500/30 rounded-lg p-1.5 sm:p-2 group-focus-within:border-blue-400/60 group-focus-within:bg-gradient-to-br group-focus-within:from-blue-600/30 group-focus-within:to-cyan-600/30 transition-all duration-300 group-focus-within:scale-110">
                    <MdPerson size={16} className="text-blue-400 group-focus-within:text-blue-300 transition-colors duration-300" />
                  </div>
                </div>
              </div>
            <input 
                    type="text" 
                    name="name" 
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name" 
                className="w-full pl-12 sm:pl-14 pr-3 sm:pr-4 py-2 sm:py-3 md:py-4 text-sm sm:text-base bg-gray-900/40 backdrop-blur-sm border-2 border-gray-700/40 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50 focus:bg-gray-900/60 transition-all duration-300 hover:border-gray-600/50"
                required
              />
            </div>

            {/* Email Input */}
            <div className="relative group">
              <div className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 z-10">
                <div className="relative">
                  {/* Glow effect */}
                  <div className="absolute inset-0 bg-cyan-500/30 rounded-lg blur-md opacity-0 group-focus-within:opacity-100 transition-opacity duration-300"></div>
                  {/* Icon container */}
                  <div className="relative bg-gradient-to-br from-cyan-600/20 to-blue-600/20 backdrop-blur-sm border border-cyan-500/30 rounded-lg p-1.5 sm:p-2 group-focus-within:border-cyan-400/60 group-focus-within:bg-gradient-to-br group-focus-within:from-cyan-600/30 group-focus-within:to-blue-600/30 transition-all duration-300 group-focus-within:scale-110">
                    <MdEmail size={16} className="text-cyan-400 group-focus-within:text-cyan-300 transition-colors duration-300" />
                  </div>
                </div>
              </div>
                    <input
                type="email"
                    name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                className="w-full pl-12 sm:pl-14 pr-3 sm:pr-4 py-2 sm:py-3 md:py-4 text-sm sm:text-base bg-gray-900/40 backdrop-blur-sm border-2 border-gray-700/40 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50 focus:bg-gray-900/60 transition-all duration-300 hover:border-gray-600/50"
                required
              />
            </div>

            {/* Message Textarea */}
            <div className="relative group">
              <div className="absolute left-3 sm:left-4 top-4 sm:top-6 z-10">
                <div className="relative">
                  {/* Glow effect */}
                  <div className="absolute inset-0 bg-purple-500/30 rounded-lg blur-md opacity-0 group-focus-within:opacity-100 transition-opacity duration-300"></div>
                  {/* Icon container */}
                  <div className="relative bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur-sm border border-purple-500/30 rounded-lg p-1.5 sm:p-2 group-focus-within:border-purple-400/60 group-focus-within:bg-gradient-to-br group-focus-within:from-purple-600/30 group-focus-within:to-pink-600/30 transition-all duration-300 group-focus-within:scale-110">
                    <MdMessage size={16} className="text-purple-400 group-focus-within:text-purple-300 transition-colors duration-300" />
                  </div>
                </div>
              </div>
                    <textarea 
                    name="message" 
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="4" 
                className="w-full pl-12 sm:pl-14 pr-3 sm:pr-4 py-2 sm:py-3 md:py-4 text-sm sm:text-base bg-gray-900/40 backdrop-blur-sm border-2 border-gray-700/40 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50 focus:bg-gray-900/60 transition-all duration-300 hover:border-gray-600/50 resize-none"
                required
              />
            </div>

            {/* Submit Button */}
                     <button 
              type="submit"
              className="group w-full px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg text-white text-xs sm:text-sm md:text-base font-semibold flex items-center justify-center gap-2 hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-blue-500/50 active:scale-95"
            >
              <span>Send Message</span>
              <MdSend 
                size={16} 
                className="sm:w-4 sm:h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform duration-300"
              />
                     </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
